module.exports = __webpack_public_path__ + "static/media/logo-rtc.b76c1d93.svg";